<div class="user-pill">
  <div class="user-avatar">
    {{ userInitials }}
  </div>
  <div class="user-info">
    <div class="user-name">{{ userName }}</div>
    <div class="user-role">{{ userRole }}</div>
  </div>
  <button class="logout-btn" (click)="logout()" title="Log off">
    <mat-icon>logout</mat-icon>
  </button>
</div>
